module.exports = __webpack_public_path__ + "static/kiddo-2313bd808eca51085522604c3e3a69cc.png";